<script>
	document.getElementsByTagName('body')[0].style.display = 'none'
	
	import {sQuery as sq} from './sq.js';
	//export let name;
	import {name, loadProc} from './docs.js'
	import Sqi from './Sq_editorI.svelte'

	if (sq().isPageLoaded())
	{
		console.log('spa loaded')
		setTimeout(() => {
			loadProc()
			appendReload()
		}, 1);
	}
	sq(()=>{
		loadProc()
		setTimeout(()=>{
			sq('.cJQVer').each(function(){
				const v = sq(this).attr('v')
				sq(this).html(`<a href="https://api.jquery.com/${v}" target=_blank class="notranslate">jQuery ${v}(doc)</a>`)
			})
			appendReload()
		}, 100)
	})
	function appendReload(){
		sq('.cDesc').each(function(){
			sq(this).append('<div class="cReload">reload</div>')
		})
		sq('.cReload').show()
		sq('.cReload').on('click', function(){
			const el = sq(this).parent().parent().find('iframe')
			el.attr('src', el.attr('src') )
		})
	}
</script>

<main>
	<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.25.0/themes/prism-tomorrow.min.css">
	<script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.25.0/prism.min.js"></script>
	<link rel="stylesheet" href="./Docs.css">
	<section id="idHead">
		<span id="idDocNav"></span>
		<div class="cBtnTrans"><a href="https://squery-vercel-app.translate.goog/?&_x_tr_sl=auto&_x_tr_tl=ja&_x_tr_hl=en&_x_tr_pto=wapp#/docs">日本語に翻訳</a></div>
	</section>
	
	<section id="idLeft">
		<section id="idLeftTop">
			<div id="idLeftLogo" class="notranslate"><a href="./" style="color:#fff">sQuery HOME</a></div>
		
			<div id="idLeftSearchCont">
				<hr>
				<div style="position:relative">
					<input id="idDS" type="text" placeholder="search docs" autocorrect="off" autocapitalize="off" spellcheck="false">
					<div id="idDSC">&times;</div>
				</div>
			</div>
		</section>

		<section class="cScrollable">
			<div style="font-weight:300">
				<div name="" class="cSub">Getting Started</div>
				<div name="Installation" class="cF">・Installation</div>
				<div name="Difference_between_jQuery" class="cF">・Difference between jQuery</div>
				<div name="Use_like_jQuery" class="cF">・Use like jQuery</div>
				<div name="Use_with_jQuery" class="cF">・Use with jQuery</div>
				<div name="Use_with_React" class="cF">・Use with React</div>
				<div name="Use_with_Vue" class="cF">・Use with Vue.js</div>
				<div name="Use_with_Svelte" class="cF">・Use with Svelte</div>
				<div name="Use_with_SolidJS" class="cF">・Use with SolidJS</div>
				<div name="Use_with_Angular" class="cF">・Use with Angular</div>
			</div>
	
			<div name="" class="cSub">Self Selectors</div>
			<div name="filter-not" class="cF notranslate">filter / not</div>
			<div name="eq" class="cF notranslate">eq</div>
			<div name="first-last" class="cF notranslate">first / last</div>
			<div name="has" class="cF notranslate">has</div>
			<div name="contains" class="cF notranslate">contains</div>
			<div name="slice" class="cF notranslate">slice</div>
			<div name="index" class="cF notranslate">index</div>
			<div name="is" class="cF notranslate">is</div>
	
			<div name="" class="cSub">Child Elements</div>
			<div name="find" class="cF notranslate">find</div>
			<div name="children" class="cF notranslate">children</div>
	
			<div name="" class="cSub">Sibling Elements</div>
			<div name="next-prev" class="cF notranslate">next / prev</div>
			<div name="siblings" class="cF notranslate">siblings</div>
	
			<div class="cSub">Parent Elements</div>
			<div name="parent-parents" class="cF notranslate">parent / parents</div>
			<div name="closest" class="cF notranslate">closest</div>

			<div name="" class="cSub">Boolean Checks</div>
			<div name="hasClass" class="cF notranslate">hasClass</div>
			
			<div name="" class="cSub">Operations</div>
			<div name="html" class="cF notranslate">html</div>
			<div name="text" class="cF notranslate">text</div>
			<div name="val" class="cF notranslate">val</div>
			<div name="css" class="cF notranslate">css</div>
			<div name="attr" class="cF notranslate">attr</div>
			<div name="prop" class="cF notranslate">prop</div>
			<div name="get" class="cF notranslate">get</div>
			<div name="show-hide" class="cF notranslate">show / hide</div>
			<div name="remove" class="cF notranslate">remove</div>
			<div name="before-after" class="cF notranslate">before / after</div>
			<div name="prepend-append" class="cF notranslate">prepend / append</div>
			<div name="replaceWith" class="cF notranslate">replaceWith / oHtml</div>
			<div name="addClass-removeClass" class="cF notranslate">addClass / removeClass</div>
			<div name="toggleClass" class="cF notranslate">toggleClass</div>

			<div name="" class="cSub">Size & Position</div>
			<div name="width-height" class="cF notranslate">width / height</div>
			<div name="innerWidth-innerHeight" class="cF notranslate">innerWidth / innerHeight</div>
			<div name="outerWidth-outerHeight" class="cF notranslate">outerWidth / outerHeight</div>
			<div name="offset" class="cF notranslate">offset</div>
			<div name="pos-position" class="cF notranslate">pos (position)</div>
			
			<div name="" class="cSub">Animations</div>
			<div name="fadeIn-fadeOut" class="cF notranslate">fadeIn / fadeOut</div>
			<div name="animate" class="cF notranslate">animate</div>
			<div name="scroll" class="cF notranslate">scroll</div>
			<div name="scrollTop-scrollLeft" class="cF notranslate">scrollTop / scrollLeft</div>
			<div name="scrollToElement" class="cF notranslate">scrollToElement</div>

			<div name="" class="cSub">Loops</div>
			<div name="each" class="cF notranslate">each</div>

			<div name="" class="cSub">Events</div>
			<div name="on-off-onf" class="cF notranslate">on / off / onf</div>
			<div name="trg-trigger" class="cF notranslate">trg (trigger)</div>

			<br><br><br><br><br><br><br><br>
		</section>
	</section>
	

	<div class="menu__toggler"><span></span></div>

	<section id="idDoc">
		<h1><span onclick="location.href='./';" style="cursor:pointer">sQuery Docs<div>{name}</div></span></h1>

		<doc name="Installation">
			<h2>Installation</h2>
			<div class="cPreDesc">
				Download <a href="https://github.com/exis9/sQuery/archive/refs/heads/main.zip" target=_blank style="font-size:18px">sQuery.zip</a> or use CDN. (<a href="https://github.com/exis9/sQuery" target="_blank">Github page</a>)
				<br><br>
				<div style="padding:10px 20px; display:inline-block;border-radius:8px;background-color:#fff">
					<h2>CDN</h2>
					Minified sQuery (production):<br>
					<a href="https://cdn.jsdelivr.net/gh/exis9/squery@latest/squery.min.js" target=_blank>https://cdn.jsdelivr.net/gh/exis9/squery@latest/squery.min.js</a><br><br>

					Uncompressed sQuery (development):<br>
					<a href="https://cdn.jsdelivr.net/gh/exis9/squery@latest/squery.js" target=_blank>https://cdn.jsdelivr.net/gh/exis9/squery@latest/squery.js</a><br><br>

					Minified ES6 Module sQuery (production):<br>
					<a href="https://cdn.jsdelivr.net/gh/exis9/squery@latest/sq.min.js" target=_blank>https://cdn.jsdelivr.net/gh/exis9/squery@latest/sq.min.js</a><br><br>

					Uncompressed ES6 Module sQuery (development):<br>
					<a href="https://cdn.jsdelivr.net/gh/exis9/squery@latest/sq.js" target=_blank>https://cdn.jsdelivr.net/gh/exis9/squery@latest/sq.js</a>
				</div>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					To use sQuery, put squery.min.js somewhere just like jQuery. <small>(NOTE: sq is equivalent to $ in jQuery)</small>
				</div>
				<Sqi cname="c1" mh="240" autoload="true"></Sqi>
			</div>
			<div style="margin-top:30px">
				<div class="cDesc"><div class="cBack"></div>Or you can also use CDN!</div>
				<Sqi cname="c1_cdn" mh="240"></Sqi>
			</div>
			<div style="margin-top:30px">
				<div class="cDesc"><div class="cBack"></div>ES6 module is also supported! <small>(NOTE: () =>｛ ｝ is the ES6's <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/Arrow_functions" target=_blank>arrow function</a>)</small></div>
				<Sqi cname="c2" mh="240"></Sqi>
			</div>
			<div style="margin-top:30px">
				<div class="cDesc"><div class="cBack"></div>ES6 module CDN!</div>
				<Sqi cname="c2_cdn" mh="240"></Sqi>
			</div>
		</doc>

		<doc name="Difference_between_jQuery">
			<h2>Difference between jQuery</h2>
			<div class="cPreDesc">
				sQuery is not a simple jQuery clone. It's made for using with modern frontend frameworks.
				There are some differences between jQuery.

				<div style="margin-top: 10px">
					<div class="cAccr">
						<h3>sQuery uses sq not $. But you can customize!</h3>
						<p>
							sQuery avoids using $ since Svelte and jQuery use $.<br>
							Actually, you <b>can</b> use $ in sQuery! See <a href="./?n=Use_with_jQuery#/docs" target=_blank>Use like jQuery</a>
						</p>
					</div>
					
					<div class="cAccr">
						<h3>sQuery doesn't have $.ajax function. Use fetch or axios instead</h3>
						<p>
							Since this is the modern trend, sQuery also doesn't have ajax functions just as <b>React/Vue/Svelte</b> do.<br>
							You should use <a href="https://github.com/axios/axios" target=_blank>axios (it's only 21KB!)</a> or <a href="https://www.javascripttutorial.net/javascript-fetch-api/" target=_blank>native fetch function</a> not $.ajax. 
							(There are some <a href="/#/examples/" target=_blank>examples</a>)
						</p>
					</div>

					<div class="cAccr">
						<h3>Never use .click(). Stick to .on() and .trigger()</h3>
						<p>
							.click() and some event methods in jQuery used to be very widely used. However it's been depricated in the latest jQuery.
							jQuery has .on() and .trigger() methods, which are faster and better. <br>
							In sQuery, you can do something like this just like the latest jQuery:<br>
							<br>
							<b>
								sq('selector').on('click', ... //registering a click event<br>
								sq('selector').trigger('click') //triggering a click event<br>
								sq('selector').trg('click') //triggering a click event (shorthand)
							</b>
						</p>
					</div>

					<div class="cAccr">
						<h3>Never use :contains / :is</h3>
						<p>
							:contains in jQuery used to be very widely used. However it's been depricated in the latest jQuery.
							<br><br>
							<b>$(":contains('selector')")</b><br>
							<br>
							sQuery also doesn't support them for various performance reasons. Instead, sQuery just supports performant methods to do the same things just like the latest jQuery does.<br>
							<br>
							<b>
								.contains('selector')<br>
								.is('selector')<br>
							</b>
						</p>
					</div>

					<div class="cAccr">
						<h3>Why sQuery doesn't support all the functions in jQuery?</h3>
						<p>
							sQuery has major core functions in jQuery.<br>
							However, it's not made for supporting everything.<br>
							sQuery is made for working with modern js frameworks such as <b>React/Vue/Svelte/Angular</b> with replacing lengthy vanilla JavaScript codes.<br>
							<br>
							As a result, with sQuery, the total code size could be smaller than without it especially in big projects.<br>
							If sQuery supports all functions and all features in jQuery, the code size would be 3 times or something? It wouldn't be worthy at all!<br>
							That's why I cut down all the unessential functions from jQuery since the purpose of sQuery is simple, solid, and small.<br>
							<br>
							For instance, let's assume the following scenario: sQuery + Vue.js:<br>
							Thanks to sQuery, you can code just like jQuery, and you can also use the virtual DOM and auto code optimizations Vue provides.<br>
							If you do DOM manipulations relatively a lot, sQuery doesn't increase the total code size as a result of cutting down of lengthy vanila JS codes, so you won't lose anything in this scenario.
						</p>
					</div>

					<div class="cAccr">
						<h3>Adding custom methods to sQuery (just like jQuery $.fn)</h3>
						<p>
							<small>NOTE: This is for maniacs. You don't even need to know this if you just want to use sQuery.</small><br>
							I didn't imprement unimportant methods in sQuery to keep it small and performant. 
							However, if you need more methods, you can always very easily imprement on your own using _SQ.
						</p>
						<div>
							<div class="cDesc">
								<div class="cBack"></div>
								Custom Methods
							</div>
							<Sqi cname="customMethods" mh="410"></Sqi>
						</div>
					</div>

				</div>
			</div>
		</doc>

		<doc name="Use_like_jQuery">
			<h2>Use like jQuery</h2>
			<div class="cPreDesc">
				<img class="cFWLogo" src="img/jquery.png" alt="jquery" title="jquery">
				sQuery might look awkward for jQuery fans since it uses sq not $.<br>
				Actually, you can use $ very easily by just declaring $.
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					Replacing sq to $
				</div>
				<Sqi cname="custom" mh="410"></Sqi>

				<div class="cDesc">
					<div class="cBack"></div>
					Replacing sq to $ (module version)
				</div>
				<Sqi cname="custom_module" mh="240"></Sqi>
			</div>
		</doc>

		<doc name="Use_with_jQuery">
			<h2>Use with jQuery</h2>
			<div class="cPreDesc">
				<img class="cFWLogo" src="img/jquery.png" alt="jquery" title="jquery">
				<b>sQuery and jQuery can work together</b> like friends!<br>
				No special codes are needed! This is great for migrating from existing jQuery projects.
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					jQuery and sQuery at the same time!
				</div>
				<Sqi cname="with_jquery" mh="410"></Sqi>
			</div>
		</doc>

		<doc name="Use_with_React">
			<h2>Use with React</h2>
			<div class="cPreDesc">
				See <a class="cFWLink" href="/?n=Use_with_React#/install" target="_blank">the sQuery Installation Guide for React</a>!<br>
				<img class="cFWLogo" src="img/react.png" alt="React.js" title="React.js">
				<div class="cFWDesc">
					<h4>What is React?</h4>
					<div class="cFWLinkCont"><a class="cFWLink cBlueBack" href="https://reactjs.org/" target=_blank>React.js Official site</a></div>
					A JavaScript library for building user interfaces.<br>
					React makes it painless to create interactive UIs. Design simple views for each state in your application, and React will efficiently update and render just the right components when your data changes.
					Declarative views make your code more predictable and easier to debug.<br>
					Performance-wise, many reserches indicate SolidJS or Svelte is the fastest among major js frameworks. If your project doesn't need Next.js, I personally recommend you to try SolidJS or Svelte.
					<br><br>
					SPA/SSR/SSG?: <a class="cFWLink cBlueBack" href="https://nextjs.org/" target=_blank>Next.js</a> is the de facto standard react framework for routing.
				</div>
			</div>
		</doc>

		<doc name="Use_with_Vue">
			<h2>Use with Vue.js</h2>
			<div class="cPreDesc">
				See <a class="cFWLink" href="/?n=Use_with_Vue#/install" target="_blank">the sQuery Installation Guide for Vue.js</a>!<br>
				<img class="cFWLogo" src="img/vuejs.png" alt="Vue.js" title="Vue.js">
				<div class="cFWDesc">
					<h4>What is Vue.js?</h4>
					<div class="cFWLinkCont"><a class="cFWLink cBlueBack" href="https://reactjs.org/" target=_blank>Vue.js Official site</a></div>
					An approachable, performant and versatile framework for building web user interfaces. 
					Builds on top of standard HTML, CSS and JavaScript with intuitive API and world-class documentation. 
					Performant. Truly reactive, compiler-optimized rendering system that rarely requires manual optimization.
					<br><br>
					SPA/SSR/SSG?: <a class="cFWLink cBlueBack" href="https://nuxtjs.org/" target=_blank>Nuxt.js</a> is the most well-used vue framework for routing.
				</div>
			</div>
		</doc>

		<doc name="Use_with_Svelte">
			<h2>Use with Svelte</h2>
			<div class="cPreDesc">
				See <a class="cFWLink" href="/?n=Use_with_Svelte#/install" target="_blank">the sQuery Installation Guide for Svelte</a>!<br>
				<img class="cFWLogo" src="img/svelte.png" alt="Svelte" title="Svelte">
				<div class="cFWDesc">
					<h4>What is Svelte?</h4>
					<div class="cFWLinkCont"><a class="cFWLink cBlueBack" href="https://reactjs.org/" target=_blank>Svelte Official site</a></div>
					Svelte is a radical new approach to building user interfaces. Whereas traditional frameworks like React and Vue do the bulk of their work in the browser, Svelte shifts that work into a compile step that happens when you build your app.
					Instead of using techniques like virtual DOM diffing, Svelte writes code that surgically updates the DOM when the state of your app changes.<br><br>
					Svelte doesn't have the Virtual DOM but it's actually one of the most performant major frameworks today.<br>
					By the way, this website is made by Svelte and sQuery!
					<br><br>
					SPA/SSR/SSG?: Svelte has multiple good frameworks for routing. <a class="cFWLink cBlueBack" href="https://kit.svelte.dev/" target=_blank>Sveltekit</a> is the official framework and will be the de facto standard in the future.
				</div>
			</div>
		</doc>

		<doc name="Use_with_SolidJS">
			<h2>Use with SolidJS</h2>
			<div class="cPreDesc">
				See <a class="cFWLink" href="/?n=Use_with_SolidJS#/install" target="_blank">the sQuery Installation Guide for SolidJS</a>!<br>
				<img class="cFWLogo" src="img/solidjs.jpg" alt="SolidJS" title="SolidJS">
				<div class="cFWDesc">
					<h4>What is SolidJS?</h4>
					<div class="cFWLinkCont"><a class="cFWLink cBlueBack" href="https://reactjs.org/" target=_blank>SolidJS Official site</a></div>
					A declarative, efficient and flexible JavaScript library for building user interfaces.<br>
					Solid stands on the shoulders of giants, particularly React and Knockout. If you've developed with React Hooks before, Solid should seem very natural. In fact, more natural as Solid's model is much simpler with no Hook rules. Every Component executes once and it is the Hooks and bindings that execute many times as their dependencies update.
					Solid follows the same philosophy as React with unidirectional data flow, read/write segregation, and immutable interfaces. It however has a completely different implementation that forgoes using a Virtual DOM.<br><br>
					SolidJS doesn't have the Virtual DOM but it's actually the most performant framework today.
					<br><br>
					SPA/SSR/SSG?: Read <a class="cFWLink cBlueBack" href="https://www.solidjs.com/guides/server" target=_blank>the official documentation</a> for SSR/SSG!
				</div>
			</div>
		</doc>

		<doc name="Use_with_Angular">
			<h2>Use with Angular</h2>
			<div class="cPreDesc">
				See <a class="cFWLink" href="/?n=Use_with_Angular#/install" target="_blank">the sQuery Installation Guide for Angular</a>!<br>
				<img class="cFWLogo" src="img/angular.png" alt="Angular" title="Angular">
				<div class="cFWDesc">
					<h4>What is Angular?</h4>
					<div class="cFWLinkCont"><a class="cFWLink cBlueBack" href="https://reactjs.org/" target=_blank>Angular Official site</a></div>
					Angular is a platform for building mobile and desktop web applications.<br>
					Angular is a TypeScript-based free and open-source web application framework led by the Angular Team at Google and by a community of individuals and corporations.
				</div>
			</div>
		</doc>



		<doc name="filter-not">
			<h2 class="notranslate">filter / not</h2>
			<div class="cPreDesc">
				filter: Reduce the set of matched elements to those that match the selector or pass the function's test. 
				<span class="cJQVer" v="filter"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					Filter the elements
				</div>
				<Sqi cname="filter" mh="410"></Sqi>
			</div>

			<div class="cPreDesc">
				<br>
				not: The opposite version of filter. Remove elements from the set of matched elements. 
				<span class="cJQVer" v="not"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					Filter the non-matched elements
				</div>
				<Sqi cname="not" mh="410"></Sqi>
			</div>
		</doc>

		<doc name="eq">
			<h2 class="notranslate">eq</h2>
			<div class="cPreDesc">
				Reduce the set of matched elements to the one at the specified index. 
				<span class="cJQVer" v="eq"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					Reduce the set using an integer indicating the 0-based position of the element.
				</div>
				<Sqi cname="eq" mh="410"></Sqi>
			</div>

			<div class="cPreDesc">
				<br>
				You can also use a minus value! (Counting backwards from the last element in the set)
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					Reduce the set using an integer indicating the position of the element, counting backwards from the last element in the set.
				</div>
				<Sqi cname="eq2" mh="410"></Sqi>
			</div>
		</doc>

		<doc name="first-last">
			<h2 class="notranslate">first / last</h2>
			<div class="cPreDesc">
				first: Reduce the set of matched elements to the first in the set. 
				<span class="cJQVer" v="first"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					first
				</div>
				<Sqi cname="first" mh="410"></Sqi>
			</div>

			<div class="cPreDesc">
				<br>
				last: Reduce the set of matched elements to the last in the set. 
				<span class="cJQVer" v="last"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					last
				</div>
				<Sqi cname="last" mh="410"></Sqi>
			</div>
		</doc>

		
		<doc name="has">
			<h2 class="notranslate">has</h2>
			<div class="cPreDesc">
				Returns boolean result of the selector argument against the collection.
				<span class="cJQVer" v="has"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					has
				</div>
				<Sqi cname="has" mh="410"></Sqi>
			</div>
		</doc>


		<doc name="contains">
			<h2 class="notranslate">contains</h2>
			<div class="cPreDesc">
				Select all elements that contain the specified text.
				<span class="cJQVer" v="contains"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					contains
				</div>
				<Sqi cname="contains" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="slice">
			<h2 class="notranslate">slice</h2>
			<div class="cPreDesc">
				Reduce the set of matched elements to a subset specified by a range of indices.
				<span class="cJQVer" v="slice"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					slice
				</div>
				<Sqi cname="slice" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="index">
			<h2 class="notranslate">index</h2>
			<div class="cPreDesc">
				Returns the index of the element in its parent
				<span class="cJQVer" v="index"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					index
				</div>
				<Sqi cname="index" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="is">
			<h2 class="notranslate">is</h2>
			<div class="cPreDesc">
				Returns whether the provided selector matches the first element in the collection.
				<span class="cJQVer" v="is"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					.is( selector )
				</div>
				<Sqi cname="is" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="find">
			<h2 class="notranslate">find</h2>
			<div class="cPreDesc">
				Returns selector match descendants from the first element in the collection.
				<span class="cJQVer" v="find"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					.find( selector )
				</div>
				<Sqi cname="find" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="children">
			<h2 class="notranslate">children</h2>
			<div class="cPreDesc">
				Returns a collection of child elements
				<span class="cJQVer" v="children"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					.children( selector )
				</div>
				<Sqi cname="children" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="next-prev">
			<h2 class="notranslate">next / prev</h2>
			<div class="cPreDesc">
				next: Returns next sibling
				<span class="cJQVer" v="next"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					next
				</div>
				<Sqi cname="next" mh="410"></Sqi>
			</div>

			<div class="cPreDesc">
				<br>
				prev: Returns the previous adjacent element.
				<span class="cJQVer" v="prev"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					prev
				</div>
				<Sqi cname="prev" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="siblings">
			<h2 class="notranslate">siblings</h2>
			<div class="cPreDesc">
				Returns a collection of sibling elements.
				<span class="cJQVer" v="siblings"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					siblings
				</div>
				<Sqi cname="siblings" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="parent-parents">
			<h2 class="notranslate">parent / parents</h2>
			<div class="cPreDesc">
				parent: Returns parent element.
				<span class="cJQVer" v="parent"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					parent
				</div>
				<Sqi cname="parent" mh="410"></Sqi>
			</div>

			<div class="cPreDesc">
				<br>
				parents: Returns recursive parent by selector.
				<span class="cJQVer" v="parents"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					parents
				</div>
				<Sqi cname="parents" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="closest">
			<h2 class="notranslate">closest</h2>
			<div class="cPreDesc">
				Returns the closest matching selector up the DOM tree.
				<span class="cJQVer" v="closest"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					closest
				</div>
				<Sqi cname="closest" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="hasClass">
			<h2 class="notranslate">hasClass</h2>
			<div class="cPreDesc">
				Returns the boolean result of checking if the first element in the collection has the className attribute.
				<span class="cJQVer" v="hasClass"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					hasClass
				</div>
				<Sqi cname="hasClass" mh="410"></Sqi>
			</div>
		</doc>


		<!--doc name="isVisible">
			<h2 class="notranslate">isVisible</h2>
			<div class="cPreDesc">
				Returns boolean result of the selector argument's visibility
				<span class="cJQVer" v="isVisible"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					isVisible
				</div>
				<Sqi cname="isVisible" mh="410"></Sqi>
			</div>
		</doc-->


		<doc name="html">
			<h2 class="notranslate">html</h2>
			<div class="cPreDesc">
				Returns the HTML text of the first element in the collection, sets the HTML if provided.
				<span class="cJQVer" v="html"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					html
				</div>
				<Sqi cname="html" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="text">
			<h2 class="notranslate">text</h2>
			<div class="cPreDesc">
				Returns the inner text of the first element in the collection, sets the text if textContent is provided.
				<span class="cJQVer" v="text"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					text
				</div>
				<Sqi cname="text" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="val">
			<h2 class="notranslate">val</h2>
			<div class="cPreDesc">
				Returns an inputs value. If value is supplied, sets all inputs in collection's value to the value argument.
				<span class="cJQVer" v="val"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					val
				</div>
				<Sqi cname="val" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="css">
			<h2 class="notranslate">css</h2>
			<div class="cPreDesc">
				Returns a CSS property value when just property is supplied. Sets a CSS property when property and value are supplied, and set multiple properties when an object is supplied.
				<span class="cJQVer" v="css"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					css(property) / css(property, value) / css(object)
				</div>
				<Sqi cname="css" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="attr">
			<h2 class="notranslate">attr</h2>
			<div class="cPreDesc">
				Without attrValue, returns the attribute value of the first element in the collection. With attrValue, sets the attribute value of each element of the collection.
				<span class="cJQVer" v="attr"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					attr
				</div>
				<Sqi cname="attr" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="prop">
			<h2 class="notranslate">prop</h2>
			<div class="cPreDesc">
				Without a value, returns the prop value of the first element in the collection. With a value, sets the prop value of each element of the collection.
				<span class="cJQVer" v="prop"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					prop
				</div>
				<Sqi cname="prop" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="get">
			<h2 class="notranslate">get</h2>
			<div class="cPreDesc">
				Returns the element at the index
				<span class="cJQVer" v="get"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					get
				</div>
				<Sqi cname="get" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="show-hide">
			<h2 class="notranslate">show / hide</h2>
			<div class="cPreDesc">
				show: Shows the specified elements
				<span class="cJQVer" v="show"></span>
				<br><br>
				hide: Hides the specified elements
				<span class="cJQVer" v="hide"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					show / hide
				</div>
				<Sqi cname="show" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="remove">
			<h2 class="notranslate">remove</h2>
			<div class="cPreDesc">
				Removes the specified elements
				<span class="cJQVer" v="remove"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					remove
				</div>
				<Sqi cname="remove" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="before-after">
			<h2 class="notranslate">before / after</h2>
			<div class="cPreDesc">
				before: Insert content, specified by the parameter, before each element in the set of matched elements.
				<span class="cJQVer" v="before"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					before
				</div>
				<Sqi cname="before" mh="410"></Sqi>
			</div>

			<div class="cPreDesc">
				<br>
				after: Insert content, specified by the parameter, after each element in the set of matched elements.
				<span class="cJQVer" v="after"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					after
				</div>
				<Sqi cname="after" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="prepend-append">
			<h2 class="notranslate">prepend / append</h2>
			<div class="cPreDesc">
				prepend: Prepends element to the first element in collection.
				<span class="cJQVer" v="prepend"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					prepend
				</div>
				<Sqi cname="prepend" mh="410"></Sqi>
			</div>

			<div class="cPreDesc">
				<br>
				append: Appends the target element to the first element in the collection.
				<span class="cJQVer" v="append"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					append
				</div>
				<Sqi cname="append" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="replaceWith">
			<h2 class="notranslate">replaceWith / oHtml</h2>
			<div class="cPreDesc">
				Replace an element with the provided new content 
				<span class="cJQVer" v="replaceWith"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					replaceWith / oHtml
				</div>
				<Sqi cname="replaceWith" mh="410"></Sqi>
			</div>
		</doc>


		<doc name="addClass-removeClass">
			<h2 class="notranslate">addClass / removeClass</h2>
			<div class="cPreDesc">
				addClass: Adds the specified class to each element in the set of matched elements.
				<span class="cJQVer" v="addClass"></span>
				<br>
				removeClass: Remove a single class from each element in the set of matched elements.
				<span class="cJQVer" v="removeClass"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					addClass / removeClass
				</div>
				<Sqi cname="addClass" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="toggleClass">
			<h2 class="notranslate">toggleClass</h2>
			<div class="cPreDesc">
				Toggles the specified class to each element in the set of matched elements.
				<span class="cJQVer" v="toggleClass"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					toggleClass
				</div>
				<Sqi cname="toggleClass" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="width-height">
			<h2 class="notranslate">width / height</h2>
			<div class="cPreDesc">
				width: Get the current computed width for the first element in the set of matched elements or set the width of every matched element.
				<span class="cJQVer" v="width"></span>
				<br>
				height: Get the current computed height for the first element in the set of matched elements or set the width of every matched element.
				<span class="cJQVer" v="height"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					width / height
				</div>
				<Sqi cname="width" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="innerWidth-innerHeight">
			<h2 class="notranslate">innerWidth / innerHeight</h2>
			<div class="cPreDesc">
				innerWidth: Get the current computed inner width (<b>including padding but not border</b>) for the first element in the set of matched elements or set the inner width of every matched element.
				<span class="cJQVer" v="innerWidth"></span>
				<br>
				innerHeight: Get the current computed inner height (<b>including padding but not border</b>) for the first element in the set of matched elements or set the height width of every matched element.
				<span class="cJQVer" v="innerHeight"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					innerWidth / innerHeight
				</div>
				<Sqi cname="innerWidth" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="outerWidth-outerHeight">
			<h2 class="notranslate">outerWidth / outerHeight</h2>
			<div class="cPreDesc">
				outerWidth: Get the current computed outer width (<b>including padding and border</b>) for the first element in the set of matched elements or set the outer width of every matched element.
				<span class="cJQVer" v="outerWidth"></span>
				<br>
				outerHeight: Get the current computed outer height (<b>including padding and border</b>) for the first element in the set of matched elements or set the outer height of every matched element.
				<span class="cJQVer" v="outerHeight"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					outerWidth / outerHeight
				</div>
				<Sqi cname="outerWidth" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="offset">
			<h2 class="notranslate">offset</h2>
			<div class="cPreDesc">
				Get the current coordinates of the first element, or set the coordinates of every element, in the set of matched elements, relative to the document.
				<span class="cJQVer" v="offset"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					offset
				</div>
				<Sqi cname="offset" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="pos-position">
			<h2 class="notranslate">pos (position)</h2>
			<div class="cPreDesc">
				Get the current coordinates of the first element in the set of matched elements, relative to the offset parent.
				<span class="cJQVer" v="pos"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					pos (position)
				</div>
				<Sqi cname="pos" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="fadeIn-fadeOut">
			<h2 class="notranslate">fadeIn / fadeOut</h2>
			<div class="cPreDesc">
				Display the matched elements by fading them to opaque. 
				<span class="cJQVer" v="fadeIn"></span>
				<div class="cNote">
					NOTE: In jQuery, you could method-chain fadeIn and fadeOut to make a blink animation, but sQuery doesn't support it for a performance reason. Just use a callback function instead if you need a blink animation.
				</div>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					fadeIn / fadeOut
				</div>
				<Sqi cname="fadeIn" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="animate">
			<h2 class="notranslate">animate</h2>
			<div class="cPreDesc">
				Perform a custom animation of a set of CSS properties.
				<div class="cNote">
					NOTE: There are some differences to the <a href="https://api.jquery.com/animate/" target=_blank style="font-size:14px"><b>jQuery's animate</b></a>. sQuery uses the native <a href="https://developer.mozilla.org/en-US/docs/Web/API/Element/animate" target=_blank style="font-size:14px"><b>ES6 native animate</b></a> method internally.
				</div>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					animate
				</div>
				<Sqi cname="animateSimple" mh="410"></Sqi>
			</div>
			
			<br>

			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					animate (More advanced Example)
				</div>
				<Sqi cname="animate" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="scroll">
			<h2 class="notranslate">scroll</h2>
			<div class="cPreDesc">
				Scroll the elements in the current chain.
				<span class="cJQVer" v="scroll"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					scroll
				</div>
				<Sqi cname="scroll" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="scrollTop-scrollLeft">
			<h2 class="notranslate">scrollTop / scrollLeft</h2>
			<div class="cPreDesc">
				Get the current vertical position of the scroll bar for the first element in the set of matched elements or set the vertical position of the scroll bar for every matched element.
				<span class="cJQVer" v="scrollTop"></span> 
				<span class="cJQVer" v="scrollLeft"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					scrollTop / scrollLeft
				</div>
				<Sqi cname="scrollTop" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="scrollToElement">
			<h2 class="notranslate">scrollToElement</h2>
			<div class="cPreDesc">
				Scroll to the first element in the set of matched elements
				<span class="cJQVer" v="scrollToElement"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					scrollToElement
				</div>
				<Sqi cname="scrollToElement" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="each">
			<h2 class="notranslate">each</h2>
			<div class="cPreDesc">
				Iterate over a jQuery object, executing a function for each matched element.
				<span class="cJQVer" v="each"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					each
				</div>
				<Sqi cname="each" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="on-off-onf">
			<h2 class="notranslate">on / off / onf</h2>
			<div class="cPreDesc">
				on: Adds event listener to collection elments.
				<span class="cJQVer" v="on"></span>
				<br>
				off: Removes event listener from collection elments. 
				<span class="cJQVer" v="off"></span>
				<br>
				onf: Adds future event listener to collection elments.
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					on / off
				</div>
				<Sqi cname="on" mh="410"></Sqi>
			</div>
			<br>

			<div class="cNote">
				NOTE: In sQuery, sq(document).onf('click', 'selector') equivalents to $(document).on('click', 'selector') in jQuery. .onf() can register future element events.
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					onf
				</div>
				<Sqi cname="onf" mh="410"></Sqi>
			</div>
		</doc>



		<doc name="trg-trigger">
			<h2 class="notranslate">trg (trigger)</h2>
			<div class="cPreDesc">
				Triggers supplied event on elements in collection.
				<span class="cJQVer" v="trigger"></span>
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					trg (trigger)
				</div>
				<Sqi cname="trg" mh="410"></Sqi>
			</div>
		</doc>




	</section>
	<br>
</main>

<style>

</style>